<template>
  <div class="feedback-info-page">
    <el-card class="app-table-container" :body-style="{ padding: '0' }">
      <div class="feedback-main">
        <div class="feedback-main-left">
          <div class="feedback-main-left-btn">
            <button
              class="global-button-style"
              @click="dialogSearchVisible = !dialogSearchVisible"
            >
              搜索
            </button>
            <div class="feedback-main-left-select">
              <el-select v-model="sortType" @change="sortSessionList">
                <el-option
                  v-for="item in sortOpts"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
              <div class="feedback-main-left-sortBy" @click="sortByTime">
                <i
                  class="el-icon-caret-top feedback-main-left-icon"
                  :class="{ activeSortIcon: sortIcon === 'up' }"
                ></i>
                <i
                  class="el-icon-caret-bottom feedback-main-left-icon"
                  :class="{ activeSortIcon: sortIcon === 'down' }"
                ></i>
              </div>
            </div>
          </div>
          <div v-bar>
            <div class="feedback-main-list">
              <div
                class="feedback-main-item"
                :class="{
                  activeUserItem: sessionItemID === item.userProfile.userID
                }"
                v-for="(item, idx) in sessionList"
                :key="idx"
                @click="handleUserItem(idx, item)"
              >
                <span
                  @click.stop="delConversation(item)"
                  class="feedback-del-btn el-icon-close"
                ></span>
                <img
                  class="feedback-main-item-pic"
                  src="@/assets/img/cmb_temp_potrait.png"
                  alt="potrait"
                />
                <div class="feedback-main-item-info">
                  <div class="feedback-main-item-Top">
                    <p
                      class="feedback-main-item-account"
                      v-if="item.lastMessage.messageForShow"
                    >
                      {{
                        item.lastMessage.messageForShow.name ||
                          item.userProfile.userID
                      }}
                    </p>
                    <p
                      v-if="item.unreadCount"
                      class="feedback-main-item-unreadCount"
                    >
                      {{ item.unreadCount }}
                    </p>
                  </div>
                  <div class="feedback-main-item-Bottom">
                    <p class="feedback-main-item-msg">
                      {{
                        item.lastMessage.messageForShow
                          ? item.lastMessage.messageForShow.desc
                          : ''
                      }}
                    </p>
                    <p class="feedback-main-item-text">
                      {{ (item.lastMessage.lastTime * 1000) | filterTime }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="feedback-main-right" v-if="sessionItem">
          <div class="feedback-userName">
            <template>
              <h2 v-if="sessionItem.remark">
                {{ sessionItem.remark }} （
                {{
                  currentUser.payload.text.name
                    ? currentUser.payload.text.name
                    : sessionItemID
                }}
                ）
              </h2>
              <h2 v-else>
                {{
                  currentUser.payload.text.name
                    ? currentUser.payload.text.name
                    : sessionItemID
                }}
              </h2>
            </template>
            <div class="blackListBtn">
              <button class="global-button-style" @click="showRemarkInput">
                备注
              </button>
            </div>
            <div class="blackListBtn">
              <button class="global-button-style" @click="addBlackList">
                黑名单
              </button>
            </div>
          </div>
          <div class="feedback-content" v-bar>
            <div
              v-if="isShowScrollButtomTips"
              class="scrollButtomTips"
              @click="scrollToBottom"
            >
              回到最新
            </div>
            <div style="flex:1;" ref="feedbackContent" @scroll="onScroll">
              <p v-if="!isCompleted" class="checkMore-btn" @click="checkMore">
                查看更多
              </p>
              <p class="feedbackContent-noMore" v-else>
                没有更多了...
              </p>
              <div
                class="feedbacl-content-item"
                v-for="(item, index) in msgList"
                :key="item.sequence"
                :id="item.msgKey ? item.msgKey : item.sequence"
                ref="contentItem"
              >
                <div class="feedbacl-content-info" v-if="item.flow === 'in'">
                  <img
                    class="feedback-content-item-pic"
                    src="@/assets/img/cmb_temp_potrait.png"
                    alt="potrait"
                  />

                  <div class="feedback-content-item-info">
                    <div class="feedback-content-item-text-warp">
                      <p
                        class="feedback-content-item-text"
                        v-html="filterDesc(item.payload.text.desc)"
                      ></p>
                      <template v-if="item.msgKey">
                        <img
                          v-if="!item.tags || !item.tags.length"
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_noTag.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                        <img
                          v-else-if="item.tags.length === 1"
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_tag.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                        <img
                          v-else
                          class="feedback-content-item-tag"
                          src="@/assets/img/icon_tags.svg"
                          alt=""
                          @click.stop="addFeedbackTags(item)"
                        />
                      </template>
                    </div>
                    <div
                      v-if="item.tags && item.tags.length"
                      class="feedback-content-item-firmware"
                    >
                      标签：
                      <span
                        class="feedback-tag-value"
                        v-for="(tag, i) in item.tags"
                        :key="tag.key"
                      >
                        {{ tag.value }}
                        <i v-if="i !== item.tags.length - 1">、</i>
                      </span>
                    </div>

                    <div
                      class="feedback-content-item-firmware"
                      v-if="item.payload.text.firmware"
                    >
                      <p v-if="item.payload.text.firmware.model">
                        型号：{{ item.payload.text.firmware.model }}
                      </p>
                      <p v-if="item.payload.text.firmware.fingerprint">
                        版本：{{
                          item.payload.text.firmware.fingerprint
                            .split('/')[2]
                            .split(':')[1]
                        }}
                      </p>
                      <p v-if="item.payload.text.firmware.deviceMAC">
                        MAC：{{ item.payload.text.firmware.deviceMAC }}
                      </p>
                      <p v-if="item.payload.text.firmware.version">
                        版本：{{ item.payload.text.firmware.version }}
                      </p>
                      <p v-if="item.payload.text.firmware.lang">
                        语言：{{ item.payload.text.firmware.lang }}
                      </p>
                      <p v-if="item.payload.text.firmware.server">
                        服务器：{{ item.payload.text.firmware.server }}
                      </p>
                      <p v-if="item.payload.text.serverInfo">
                        服务器：{{
                          item.payload.text.serverInfo.onyxSend2BooxHostBaseUrl
                        }}
                      </p>
                      <p v-if="item.payload.text.firmware.buildDisplayId">
                        buildDisplayId：{{
                          item.payload.text.firmware.buildDisplayId
                        }}
                      </p>
                      <p v-if="item.payload.text.firmware.buildType">
                        buildType：{{ item.payload.text.firmware.buildType }}
                      </p>
                    </div>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.payload.text.serialNumber"
                    >
                      SN码：{{ item.payload.text.serialNumber }}
                    </p>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.payload.text.phone"
                    >
                      手机：{{ item.payload.text.phone }}
                    </p>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.payload.text.email"
                    >
                      邮箱：{{ item.payload.text.email }}
                    </p>
                    <p
                      class="feedback-content-item-file"
                      v-if="item.payload.text.uploadFileUrl"
                    >
                      附件：
                      <a
                        v-if="
                          item.payload.text.uploadFileUrl.indexOf(
                            'onyx-log-collection'
                          ) !== -1 ||
                            item.payload.text.uploadFileUrl.indexOf(
                              'onyx-log-collection-us'
                            ) !== -1
                        "
                        target="_blank"
                        class="feedback-content-item-fileUrl"
                        :href="item.payload.text.uploadFileUrl"
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <a
                        v-else-if="
                          item.payload.text.uploadFileUrl.indexOf(
                            'oss-us-west-1'
                          ) !== -1 &&
                            item.payload.text.uploadFileUrl.indexOf(
                              'onyx-log-collection-us'
                            ) === -1
                        "
                        class="feedback-content-item-fileUrl"
                        target="_blank"
                        :href="
                          `https://onyx-log-collection-us.${item.payload.text.uploadFileUrl}`
                        "
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <a
                        v-else
                        class="feedback-content-item-fileUrl"
                        :href="item.payload.text.uploadFileUrl"
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <el-button
                        v-if="item.payload.text.key"
                        type="primary"
                        size="mini"
                        @click="checkPsw(item.payload.text)"
                        >密码查询</el-button
                      >
                    </p>
                    <p class="feedback-content-item-time">
                      {{ (item.time * 1000) | filterTime }}
                    </p>
                  </div>
                </div>
                <div class="feedbacl-content-info feedbacl-content-out" v-else>
                  <div
                    class="feedback-content-item-info feedbacl-content-out-text"
                  >
                    <div style="display: flex; align-items:center;">
                      <span
                        v-if="
                          item.status === 'unSend' || item.status === 'fail'
                        "
                        @click.stop="resendMsg(item, index)"
                        class="feedback-sendFail-btn el-icon-warning"
                      ></span>
                      <p
                        class="feedback-content-item-text feedbacl-out-content-text"
                        v-html="filterDesc(item.payload.text.desc)"
                      ></p>
                    </div>

                    <p
                      class="feedback-content-item-file"
                      v-if="item.payload.text.uploadFileUrl"
                    >
                      附件：
                      <a
                        v-if="
                          item.payload.text.uploadFileUrl.indexOf(
                            'onyx-log-collection'
                          ) !== -1 ||
                            item.payload.text.uploadFileUrl.indexOf(
                              'onyx-log-collection-us'
                            ) !== -1
                        "
                        target="_blank"
                        class="feedback-content-item-fileUrl"
                        :href="item.payload.text.uploadFileUrl"
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <a
                        v-else-if="
                          item.payload.text.uploadFileUrl.indexOf(
                            'oss-us-west-1'
                          ) !== -1 &&
                            item.payload.text.uploadFileUrl.indexOf(
                              'onyx-log-collection-us'
                            ) === -1
                        "
                        class="feedback-content-item-fileUrl"
                        target="_blank"
                        :href="
                          `https://onyx-log-collection-us.${item.payload.text.uploadFileUrl}`
                        "
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <a
                        v-else
                        class="feedback-content-item-fileUrl"
                        :href="item.payload.text.uploadFileUrl"
                        download=""
                        >{{
                          item.payload.text.uploadFileUrl.split('/').pop()
                        }}</a
                      >
                      <el-button
                        v-if="item.payload.text.key"
                        type="primary"
                        size="mini"
                        @click="checkPsw(item.payload.text)"
                        >密码查询</el-button
                      >
                    </p>

                    <p class="feedback-content-item-time">
                      {{ (item.time * 1000) | filterTime }}
                    </p>
                    <span
                      v-if="filterRevokeTime(item)"
                      @click.stop="revokeMsg(item)"
                      class="feedback-revoke-btn el-icon-close"
                    ></span>
                  </div>
                  <div class="feedback-content-item-pic-wrap">
                    <img
                      class="feedback-content-item-pic"
                      src="@/assets/img/cmb_temp_potrait.png"
                      alt="potrait"
                    />
                    <p>{{ item.payload.text.name }}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- 附件上传 -->
          <div class="feedback-file">
            <el-upload
              class="upload"
              action=""
              ref="uploader"
              :on-change="handleChange"
              :show-file-list="false"
              :auto-upload="false"
            >
              <img
                slot="trigger"
                src="@/assets/img/icon_feedback_file.svg"
                alt=""
              />
            </el-upload>
            <!-- <div class="feedback-file-line"></div> -->
            <div class="feedback-upload-file" v-if="files.length">
              <el-tag
                v-for="file in files"
                :key="file.uid"
                closable
                @close="files = []"
                disable-transitions
              >
                {{ file.name }}
              </el-tag>
            </div>
          </div>
          <div class="feedback-input" v-loading="sending">
            <el-input
              v-model="content"
              placeholder="输入内容..."
              type="textarea"
              id="singleText"
              resize="none"
              @focus="focusInput"
              @keydown.enter.exact.prevent.native="sendMsg"
              @keyup.ctrl.enter.prevent.exact.native="handleLine"
            ></el-input>
            <div class="feedback-sendBtn">
              <Idioms @setIdioms="setIdioms" />
              <button @click="sendMsg" class="global-button-style">
                发送
              </button>
            </div>
          </div>
        </div>
        <div v-else class="feedback-main-right"></div>
      </div>
    </el-card>

    <el-dialog
      title="信息反馈搜索"
      class="feedback-dialog-main"
      :visible.sync="dialogSearchVisible"
    >
      <div class="feedback-dialogSearch-warp">
        <div class="feedback-dialogSearch-input">
          <el-select
            v-model="searchType"
            @change="changeSelectType"
            class="feedback-dialogSearch-select"
          >
            <el-option
              v-for="item in searchOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>

          <el-input
            v-model="searchVal"
            placeholder="输入搜索内容"
            clearable
            @keydown.enter.native="feedbackSearch"
            ><i
              slot="suffix"
              class="el-input__icon el-icon-search feedback-dialogSearch-search-icon"
              @click.stop="feedbackSearch"
            ></i
          ></el-input>
        </div>
        <div class="feedback-searchList" v-bar>
          <div>
            <div
              v-for="item in searchList"
              :key="item._id"
              class="feedback-searchItem"
              @click="searchToHandleUserItem(item)"
            >
              <img
                class="feedback-main-item-pic"
                src="@/assets/img/cmb_temp_potrait.png"
                alt="potrait"
              />
              <div class="feedback--searchItem-msgInfo">
                <!-- <h4>
                  {{
                    JSON.parse(
                      JSON.parse(
                        JSON.stringify(item.MsgBody[0].MsgContent.Text)
                      )
                    ).name
                  }}：
                </h4> -->
                <h4>{{ item.CustomMsgData.name }}：</h4>
                <!-- <span>{{
                  JSON.parse(
                    JSON.parse(JSON.stringify(item.MsgBody[0].MsgContent.Text))
                  ).desc
                }}</span> -->
                <span v-html="searchKeyVal(item)"></span>
              </div>
            </div>
          </div>
        </div>
        <Pagination
          layout="prev, pager, next"
          :pageSize="searchParams.limit"
          :total="searchCount"
          @pageNum="pageNum"
        />
      </div>
    </el-dialog>

    <el-dialog
      class="tagsTree-dialog"
      :visible.sync="showTagsTree"
      width="80%"
      title="标签"
      center
      @close="closeTagsPopver"
      @open="openTagsPopver"
    >
      <div class="feedback-tagsTree-header">
        <div class="feedback-tagsTree-selectTags">
          <span class="feedback-tag-value">已选：</span>
          <span
            class="feedback-tag-value"
            v-for="(tag, i) in currentMsgTags"
            :key="tag.key"
          >
            {{ tag.value }}
            <i v-if="i !== currentMsgTags.length - 1">、</i>
          </span>
        </div>
        <div class="feedback-tagsTree-btn">
          <Search
            class="feedback-tagsTree-search"
            @listSearchEvn="tagsTreeSearch"
          ></Search>
          <el-button @click="clearSelectTags">清空</el-button>
          <el-button type="primary" @click="tagsConfirm">确定</el-button>
        </div>
      </div>
      <div class="feedback-tagsTree" v-bar>
        <div>
          <div
            class="feedback-tagsFunct feedback-tags-item"
            v-for="(data, index) in tagsData"
            :key="data._id"
          >
            <div class="feedback-tags-item-left">
              <p class="feedback-tags-item-type">
                {{ index + 1 }}、{{ data.label }}
              </p>
              <div class="feedback-tags-funct-list" v-bar>
                <div>
                  <p
                    class="feedback-tags-funct-item"
                    :class="[
                      {
                        'active-functItem': item._id === data.selectItem._id
                      },
                      { 'functItem-color': item.indeterminate }
                    ]"
                    v-for="item in data.list"
                    :key="item._id"
                    @click="setTagChildren(data, item)"
                  >
                    {{ item.value }}
                  </p>
                </div>
              </div>
            </div>
            <div class="feedback-tags-item-right" v-bar>
              <div>
                <div class="feedback-tags-list">
                  <div
                    class="feedback-tags-item-check"
                    v-for="item in data.selectItemChildren"
                    :key="item._id"
                  >
                    <el-checkbox
                      v-model="item.check"
                      @change="tagsSelectHandle(data, item)"
                    ></el-checkbox>
                    <p
                      class="omitText"
                      @click="
                        ;(item.check = !item.check),
                          tagsSelectHandle(data, item)
                      "
                    >
                      {{ item.value }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>

    <el-dialog
      title="备注"
      :visible.sync="showRemark"
      width="35%"
      center
      @close="clearRemark"
    >
      <div>
        <el-input
          v-model="remarkVal"
          @keyup.enter.native="setRemark"
          clearable
        ></el-input>
      </div>
      <span slot="footer">
        <el-button @click="clearRemark">取消</el-button>
        <el-button type="primary" @click="setRemark">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import OSS from 'ali-oss'
import Pagination from '@/components/pagination'
import Search from '@/components/listSearch'
import Idioms from '../components/idioms'
export default {
  name: 'sessionList',
  props: ['refresh'],
  components: {
    Pagination,
    Search,
    Idioms
  },
  computed: {
    ...mapGetters([
      'imMsgList',
      'imSessionList',
      'userInfo',
      'ctrlItem',
      'buckets'
    ])
  },
  data() {
    return {
      sortOpts: [
        { label: '全部', value: 'all' },
        { label: '已读', value: 'read' },
        { label: '未读', value: 'unread' }
      ],
      sortType: 'all',
      sortIcon: 'down',
      searchOptions: [
        { label: '内容', value: 'text' },
        { label: '用户名', value: 'name' },
        { label: '备注', value: 'remark' },
        { label: 'MAC', value: 'mac' },
        { label: '手机', value: 'phone' },
        { label: '邮箱', value: 'email' },
        { label: 'MsgKey', value: 'MsgKey' }
      ],
      searchType: 'text',
      content: '',
      msgList: this.imMsgList || [],
      sessionList: this.imSessionList || [],
      sessionItem: null,
      sessionItemID: '',
      currentUser: {
        payload: {
          text: {
            // name: "",
            // userID: ""
          }
        }
      },
      nextReqMessageID: '',
      isCompleted: false,
      imIsCompleted: false,
      firstItemID: '',
      isShowScrollButtomTips: false,
      dialogSearchVisible: false,
      popoverVisible: false,
      searchVal: '',
      searchCount: 0,
      searchList: [],
      revokeMessage: [],
      resendMessage: [],
      searchParams: {
        limit: 20,
        page: 1
      },
      serverMsg: [],
      serverMsgCount: 0,
      serverMsgPage: 1,
      files: [],
      ossClient: null,
      uploadFileUrl: '',
      sending: false,
      currentMsgItem: null,
      currentMsgTagsKey: [],
      currentMsgTags: [],
      showTagsTree: false,
      defaultProps: {
        children: 'children',
        label: 'value'
      },
      tagLoading: false,
      defaultExpand: false,
      activeBtn: 'active-tree-minus',
      tagsData: [],
      selectTags: [],
      tagsSearchValue: '',
      showRemark: false,
      remarkVal: ''
    }
  },
  watch: {
    imMsgList() {
      this.msgList = this.imMsgList
      for (let item of this.msgList) {
        if (item.flow === 'in') {
          this.currentUser = item
          break
        }
      }
    },
    async imSessionList() {
      this.getSessionList()
    },
    refresh() {
      this.getSessionList()
      this.checkMsgKey()
      this.scrollToBottom()
    }
  },
  methods: {
    showRemarkInput() {
      this.showRemark = true
    },

    clearRemark() {
      this.showRemark = false
      this.remarkVal = ''
    },

    async setRemark() {
      await this.$http.updatefeedbackRemark({
        account: this.sessionItemID,
        remark: this.remarkVal
      })
      this.$store.dispatch('updateSessionList', this.sessionList)
      this.clearRemark()
    },

    handleChange(file, files) {
      if (file.size > 20971520) {
        this.elMsg('文件大小超过20M限制', 'error')
        return
      }
      this.$nextTick(() => {
        this.files = []
        this.files = [...this.files, file]
      })
    },

    uploadFileToOss() {
      return new Promise(async (resolve, reject) => {
        try {
          this.ossClient = await this.getOssClient()

          for (let item of this.files) {
            let file = item.raw
            let format = file.name.split('.').pop()
            let randomName = `upload/${this.randomString(
              6
            )}-${new Date().getTime()}.${format}`

            let ret = await this.ossClient.multipartUpload(randomName, file)
            this.uploadFileUrl = ret.res.requestUrls[0].split('?')[0]
            resolve('ok')
          }
          resolve('')
        } catch (error) {
          console.log(error)
          reject(error)
        }
      })
    },

    getOssClient() {
      return new Promise(async (resolve, reject) => {
        try {
          let res = await this.$http.aliyunSts()
          let { region, bucket } = this.buckets['onyx-log']
          let creds = res.data
          let client = new OSS({
            region,
            accessKeyId: creds.AccessKeyId,
            accessKeySecret: creds.AccessKeySecret,
            stsToken: creds.SecurityToken,
            bucket
          })
          return resolve(client)
        } catch (error) {
          reject(error)
        }
      })
    },

    randomString(len) {
      len = len || 32
      var chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'
      var maxPos = chars.length
      var pwd = ''
      for (let i = 0; i < len; i++) {
        pwd += chars.charAt(Math.floor(Math.random() * maxPos))
      }
      return pwd
    },

    sortSessionList() {
      return new Promise((resolve, reject) => {
        let arr = Object.assign([], this.imSessionList)
        if (this.sortType === 'all') {
          this.sessionList = arr
        } else if (this.sortType === 'read') {
          this.sessionList = arr.filter((item) => item.unreadCount === 0)
        } else if (this.sortType === 'unread') {
          this.sessionList = arr.filter((item) => item.unreadCount >= 1)
        }
        if (this.sortIcon === 'up') {
          this.sessionList.reverse()
        }
        console.log('sessionListView-------:', this.sessionList)
        console.log('sessionListCount======:', this.sessionList.length)
        resolve('ok')
      })
    },
    sortByTime() {
      this.sortIcon = this.sortIcon === 'down' ? 'up' : 'down'
      this.sessionList.reverse()
    },
    filterLogUrl(url) {
      let arr = url.split('://')
      let path = `${arr[0]}://onyx-log-collection-us.${arr[1]}`
      return path
    },
    filterDesc(desc) {
      let val = desc ? desc.replace(/\n/g, '<br>') : ''
      return val
    },
    changeSelectType() {
      this.searchVal = ''
      this.searchParams.page = 1
      this.searchCount = 0
      this.searchList = []
      delete this.searchParams.mac
      delete this.searchParams.phone
      delete this.searchParams.name
      delete this.searchParams.email
      delete this.searchParams.text
      delete this.searchParams.MsgKey
      delete this.searchParams.remark
    },
    feedbackSearch() {
      this.searchParams[this.searchType] = this.searchVal
      this.$http.feedbackSearch(this.searchParams).then((res) => {
        let { count, results } = res.data
        if (!count || !results.length) {
          this.elMsg('没有搜索到内容', 'info')
        }
        this.searchCount = count
        this.searchList = results
      })
    },
    pageNum(page) {
      this.searchParams.page = page
      this.feedbackSearch()
    },
    searchKeyVal(item) {
      let res = new RegExp(`(${this.searchVal})`, 'g')
      let text = item.CustomMsgData.desc
      text = text.replace(
        res,
        "<span style='color:red;'>" + this.searchVal + '</span>'
      )
      return text
    },
    // parseMesssageForShow(item) {
    //   if (item.lastMessage.messageForShow) {
    //     try {
    //       let msg = JSON.parse(item.lastMessage.messageForShow);
    //       return msg;
    //     } catch (error) {
    //       return null;
    //     }
    //   } else {
    //     return null;
    //   }
    // },
    // stringToJson(str) {
    //   try {
    //     return JSON.parse(str);
    //   } catch (error) {
    //     return {};
    //   }
    // },
    async searchToHandleUserItem(searchItem) {
      let userItem = null
      userItem = this.sessionList.find((item) => {
        return item.userProfile.userID === searchItem.From_Account
      })

      if (userItem) {
        this.nextReqMessageID = ''

        this.serverMsgPage = 1
        this.serverMsgCount = 0
        this.serverMsg = []
        this.imIsCompleted = false
        this.sessionItem = userItem
        this.sessionItemID = userItem.userProfile.userID
        for (var i = 0; i < this.sessionList.length; i++) {
          if (this.sessionList[i].userProfile.userID === this.sessionItemID) {
            this.sessionList.unshift(this.sessionList[i])
            this.sessionList.splice(i, 1)
            break
          }
        }
        this.$store.dispatch('imUserItem', userItem)
        this.getMsgList()
      } else {
        let res = await this.$tim.getConversationProfile(
          `C2C${searchItem.From_Account}`
        )
        let item = res.data.conversation
        this.nextReqMessageID = ''
        this.serverMsgPage = 1
        this.serverMsgCount = 0
        this.serverMsg = []
        this.imIsCompleted = false
        this.sessionItem = item
        this.sessionItemID = item.userProfile.userID
        this.$store.dispatch('imUserItem', item)
        setTimeout(() => {
          this.getMsgList()
        }, 500)
      }

      this.dialogSearchVisible = false
    },
    handleUserItem(idx, item) {
      if (this.sessionItemID === item.userProfile.userID) return
      this.serverMsgPage = 1
      this.serverMsgCount = 0
      this.serverMsg = []
      this.nextReqMessageID = ''
      this.imIsCompleted = false
      this.sessionItem = item
      this.sessionItemID = item.userProfile.userID
      this.$store.dispatch('imUserItem', item)
      if (this.$route.query.MsgKey) {
        this.$router.push({ path: this.$route.path })
      }
      this.getMsgList()
    },
    async getMsgList() {
      // 拉取服务器的数据
      // await axios({
      //   method: 'get',
      //   url: 'http://192.168.11.110:7002/api/1/im/getFeedbackDialog',
      //   crossOrigin: true,
      //   headers: {
      //     "Content-Type": "application/json;charset=utf-8"
      //   },
      //   params: {user: this.sessionItemID}
      // }).then(ret => {
      //   // 组装数据
      //   for (let i = 0; i < ret.data.length; i++) {
      //     let obj = {
      //       flow: ret.data[i].From_Account==='feedback'?'out':'in',
      //       time: (new Date(ret.data[i].MsgTime)).valueOf(),
      //       payload: {
      //         text: ret.data[i].MsgBody[0].MsgContent.Text
      //       }
      //     }
      //     msgArr.push(obj)
      //   }
      // })

      // 拉取服务器的数据
      let ret = await this.$http.getFeedbackDialog({
        user: this.sessionItemID,
        page: this.serverMsgPage,
        limit: 20
      })
      this.serverMsgCount = ret.data.count
      // 组装数据
      for (let i = 0; i < ret.data.results.length; i++) {
        let obj = {
          flow: ret.data.results[i].From_Account === 'feedback' ? 'out' : 'in',
          time: new Date(ret.data.results[i].MsgTime).valueOf(),
          random: ret.data.results[i].MsgRandom,
          sequence: ret.data.results[i].MsgSeq,
          msgKey: ret.data.results[i].MsgKey,
          tags: ret.data.results[i].tags,
          payload: {
            text: ret.data.results[i].MsgBody[0].MsgContent.Text
          }
        }
        this.serverMsg = [obj, ...this.serverMsg]
      }

      // 拉取im数据
      let imResponse = await this.$tim.getMsgList(
        this.sessionItem.conversationID,
        this.nextReqMessageID,
        15
      )

      let msgList = []
      let msgArr = []
      if (!this.imIsCompleted) {
        let _msgList = imResponse.data.messageList.filter(
          (item) => !item.isRevoked
        )
        // console.log('腾讯数据:', _msgList)
        // console.log('服务器数据:', serverMsg)
        this.serverMsg.map((item) => {
          _msgList.map((subItem, index) => {
            if (item.sequence === subItem.sequence) {
              _msgList.splice(index, 1)
            }
          })
        })
        if (!this.nextReqMessageID) {
          msgList = [...this.serverMsg, ..._msgList]
        } else {
          let arr = [...this.serverMsg, ..._msgList]
          msgArr = this.filterMsgList(arr)
          msgList = [...msgArr, ...this.msgList]
        }
      } else {
        msgArr = this.filterMsgList(this.serverMsg)
        msgList = [...msgArr, ...this.msgList]
      }
      this.$store.dispatch('updateMsgList', msgList)
      !this.nextReqMessageID && this.serverMsgPage === 1
        ? this.scrollToBottom()
        : this.scrollInSitu()

      if (this.$route.query.MsgKey) {
        this.scrollToMsg()
      }

      this.imIsCompleted = imResponse.data.isCompleted
      this.isCompleted =
        imResponse.data.isCompleted &&
        this.serverMsg.length >= this.serverMsgCount
      this.nextReqMessageID = !imResponse.data.isCompleted
        ? imResponse.data.nextReqMessageID
        : ''
    },

    filterMsgList(list) {
      let msgArr = JSON.parse(JSON.stringify(list))
      this.msgList.map((item) => {
        msgArr.map((subItem, index) => {
          if (item.sequence === subItem.sequence) {
            msgArr.splice(index, 1)
          }
        })
      })
      return msgArr
    },

    async sendMsg() {
      if (this.content === '' || this.content.trim().length === 0) {
        this.content = ''
        this.elMsg('不能发送空消息', 'warning')
        return
      }

      this.sending = true
      if (this.files.length) {
        await this.uploadFileToOss()
      }

      let params = {
        desc: this.content,
        uploadFileUrl: this.uploadFileUrl,
        name: this.userInfo.nickname
      }
      let user = this.sessionItem.userProfile.userID
      let msg = await this.$tim.createTextMessage(user, JSON.stringify(params))
      try {
        this.content = ''
        this.uploadFileUrl = ''
        this.files = []
        let res = await this.$tim.sendMsg(msg)
        this.sending = false
        this.revokeMessage = [...this.revokeMessage, res.data.message]
        this.$store.commit('SET_MSG_LIST', res.data.message)
        this.scrollToBottom()
        await this.$tim.setMessageRead(this.sessionItem.conversationID)
        // this.sessionSort();
        // this.getMsgList();
      } catch (err) {
        this.elMsg('信息发送失败，请重新发送', 'error')
        this.resendMessage = [...this.resendMessage, msg]
        this.$store.commit('SET_MSG_LIST', msg)
        this.scrollToBottom()
      }
    },

    sessionSort() {
      let a = []
      let b = []
      for (let item of this.sessionList) {
        if (item.unreadCount) {
          a.push(item)
        } else {
          b.push(item)
        }
      }
      let arr = [...a, ...b]
      this.$store.dispatch('updateSessionList', arr)
    },

    async checkPsw(item) {
      try {
        let res = await this.$http.getFeedbackPsw(item.key, {
          serverHost: item.serverInfo.onyxSend2BooxHostBaseUrl
        })
        this.openCheckPsw(res.data)
      } catch (error) {
        this.elMsg('密码查询失败', 'error')
      }
    },

    openCheckPsw(data) {
      this.$confirm(data.key, '密码查询', {
        confirmButtonText: '复制',
        showCancelButton: false,
        callback: async (type) => {
          if (type === 'confirm') {
            await this.$copyText(data.key)
            this.elMsg('复制成功', 'success')
          }
        }
      })
    },

    handleLine() {
      this.content += '\n'
    },

    scrollToBottom() {
      this.$nextTick(() => {
        let bar = this.$refs.feedbackContent || null
        bar ? (bar.scrollTop = bar.scrollHeight) : null
      })
    },

    scrollInSitu() {
      this.$nextTick(() => {
        let length = this.$refs.contentItem.length - 1
        let item = this.$refs.contentItem[length]
        let bar = this.$refs.feedbackContent
        bar.scrollTop = item.offsetTop
      })
    },

    scrollToMsg() {
      this.$nextTick(() => {
        let currentMsg = this.$refs.contentItem.find(
          (item) => this.$route.query.MsgKey === item.id
        )
        let bar = this.$refs.feedbackContent
        bar.scrollTop = currentMsg.offsetTop
      })
    },

    async delConversation(item) {
      await this.$tim.delConversation(item.conversationID)
      if (
        this.sessionItem &&
        this.sessionItem.conversationID === item.conversationID
      ) {
        this.nextReqMessageID = ''
        this.serverMsgPage = 1
        this.serverMsgCount = 0
        this.serverMsg = []
        this.imIsCompleted = false
        this.isShowScrollButtomTips = false
        this.sessionItem = null
        this.sessionItemID = ''
        this.$store.dispatch('imUserItem', this.sessionItem)
      }
    },

    filterRevokeTime(item) {
      let nowDate = new Date().getTime()
      let time = item.time * 1000
      return nowDate - time < 2 * 60 * 1000
    },
    async resendMsg(msg, index) {
      try {
        let obj = this.resendMessage.find((item) => item.ID === msg.ID)
        let params = obj ? obj : msg
        let res = await this.$tim.sendMsg(params)
        this.msgList.splice(index, 1, res.data.message)
        this.$store.dispatch('updateMsgList', this.msgList)
      } catch (error) {
        this.elMsg('信息发送失败，请重新发送', 'error')
      }
    },

    async revokeMsg(msg) {
      try {
        let obj = this.revokeMessage.find((item) => item.ID === msg.ID)
        let params = obj ? obj : msg
        await this.$tim.revokeMsg(params)
        await this.$http.revokeMessage({
          msg: params.clientSequence ? params.clientSequence : '',
          imAccount: params.to
        })
        this.msgList = this.msgList.filter((item) => item.ID !== msg.ID)
        this.$store.dispatch('updateMsgList', this.msgList)
        // let res = await this.$tim.getConversationList();
        // this.$store.dispatch("updateSessionList", res.data.conversationList);
      } catch (error) {
        this.elMsg('消息撤回超过了时间限制（默认2分钟)', 'error')
      }
    },

    // async filterImSessionList() {
    //   return new Promise(async (resolve, reject) => {
    //     let arr = [];
    //     arr = this.sessionList.filter(item => {
    //       return !item.lastMessage.messageForShow;
    //     });
    //     if (!arr.length) {
    //       resolve("ok");
    //       return;
    //     }
    //     let arrId = arr.map(item => item.toAccount);
    //     try {
    //       let res = await this.$http.filiterFeedbackList({ ids: arrId });
    //       for (let item of res.data) {
    //         for (let obj of this.sessionList) {
    //           if (item._id === obj.toAccount) {
    //             obj.lastMessage.messageForShow = item.CustomMsgData;
    //             obj.lastMessage.lastTime = new Date(item.MsgTime).valueOf();
    //             continue;
    //           }
    //         }
    //       }
    //       resolve("ok");
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // },

    checkMore() {
      this.serverMsgPage += 1
      this.getMsgList()
    },

    onScroll() {
      let bar = this.$refs.feedbackContent || null
      this.isShowScrollButtomTips = bar
        ? bar.scrollHeight - bar.clientHeight - bar.scrollTop > 200
        : false
    },

    focusInput() {},

    async setIdioms(text) {
      const myField = document.getElementById('singleText')
      if (myField.selectionStart || myField.selectionStart === 0) {
        var startPos = myField.selectionStart
        var endPos = myField.selectionEnd
        this.content =
          myField.value.substring(0, startPos) +
          text +
          myField.value.substring(endPos, myField.value.length)
        await this.$nextTick()
        myField.focus()
        myField.setSelectionRange(endPos + text.length, endPos + text.length)
      } else {
        this.content += text
      }
    },

    async getSessionList() {
      let modelBlacklists = await this.$http.getModelBlacklist({
        limit: 10000
      })
      let models = modelBlacklists.data.results.map((item) => item.model)
      let listArr = Object.assign([], this.imSessionList)

      let blackList = []
      let temp = []
      for (let item of listArr) {
        if (
          item.lastMessage.messageForShow.firmware &&
          models.includes(item.lastMessage.messageForShow.firmware.model)
        ) {
          let obj = {
            account: item.userProfile.userID,
            userId: item.userProfile.userID,
            name: item.lastMessage.messageForShow.name,
            phone: item.lastMessage.messageForShow.phone,
            email: item.lastMessage.messageForShow.email,
            sn: item.lastMessage.messageForShow.serialNumber,
            mac: item.lastMessage.messageForShow.firmware.deviceMAC,
            model: item.lastMessage.messageForShow.firmware.model
          }
          blackList = [...blackList, obj]
          console.log('将要拉黑的名单=======：', blackList)
        } else {
          temp = [...temp, item]
        }
      }
      if (blackList.length) {
        let userIds = blackList.map((item) => item.account) || []
        await this.$http.addBlacklists({ datas: blackList })
        await this.$tim.addToBlacklist(userIds)
        for (let id of userIds) {
          await this.$tim.delConversation(`C2C${id}`)
        }
      }

      await this.sortSessionList()
    },

    async addBlackList() {
      try {
        await this.$confirm(null, '是否确认加入黑名单？', {
          confirmButtonText: this.$t('commonMsg.confirm'),
          cancelButtonText: this.$t('commonMsg.cancel'),
          showClose: false,
          center: true
        })
        let obj = {
          account: this.sessionItemID,
          userId: this.sessionItemID,
          name: this.currentUser.payload.text.name,
          phone: this.currentUser.payload.text.phone,
          email: this.currentUser.payload.text.email,
          sn: this.currentUser.payload.text.serialNumber,
          mac: this.currentUser.payload.text.firmware.deviceMAC,
          model: this.currentUser.payload.text.firmware.model
        }
        await this.$http.addBlacklists({ datas: [obj] })
        await this.$tim.addToBlacklist([this.sessionItemID])
        await this.$tim.delConversation(`C2C${this.sessionItemID}`)
        this.nextReqMessageID = ''
        this.serverMsgPage = 1
        this.serverMsgCount = 0
        this.serverMsg = []
        this.imIsCompleted = false
        this.sessionItem = null
        this.sessionItemID = ''
        this.$store.dispatch('imUserItem', this.sessionItem)
      } catch (error) {}
    },

    //  ==============================================================

    async addFeedbackTags(item) {
      this.currentMsgItem = item
      this.currentMsgTags = this.currentMsgItem.tags
        ? JSON.parse(JSON.stringify(this.currentMsgItem.tags))
        : []
      this.showTagsTree = true
    },

    async openTagsPopver() {
      this.currentMsgTagsKey =
        this.currentMsgTags && this.currentMsgTags.length
          ? this.currentMsgTags.map((i) => i.key)
          : []

      let res = await this.$http.getFeedbackTagsTree({
        value: this.tagsSearchValue
      })
      for (let data of res.data) {
        if (data.list.length) {
          for (let obj of data.list) {
            this.filterTagsData(obj, data.key)
          }
          this.setTagChildren(data, data.list[0])
          this.childrenHasCheck(data)
        }
      }
      this.tagsData = res.data
      // this.getSelectTags()
    },

    filterTagsData(item, category) {
      item.category = category
      if (!item.parent || item.parent === null) {
        item.indeterminate = false
      }
      if (this.currentMsgTagsKey.includes(item.key)) {
        item.check = true
      } else {
        item.check = false
      }
      if (item.children.length) {
        for (let data of item.children) {
          this.filterTagsData(data, category)
        }
      }
    },

    setTagChildren(parent, item) {
      parent.selectItem = item
      parent.selectItemChildren = item.children
    },

    childrenHasCheck(data) {
      for (let parent of data.list) {
        if (parent.children.length) {
          parent.indeterminate = parent.children.some((item) => item.check)
        }
      }
      // this.getSelectTags()
    },

    tagsSelectHandle(data, item) {
      this.childrenHasCheck(data)
      let arr = []
      if (item.check) {
        let parentArr = this.findParent(data.list, item.parent)
        for (let data of parentArr.reverse()) {
          arr = [
            ...arr,
            {
              category: data.category,
              key: data.key,
              value: data.value
            }
          ]
        }
        let current = {
          parent: arr,
          key: item.key,
          value: item.value,
          category: item.category
        }
        this.currentMsgTags = [...this.currentMsgTags, current]
      } else {
        let index = this.currentMsgTags.find((obj) => obj.key === item.key)
        this.currentMsgTags.splice(index, 1)
      }
    },

    radioHandle(data, item) {
      if (item.check) {
        this.filterRadioStatus(data, item)
      }
    },

    filterRadioStatus(data, item) {
      for (let obj of data) {
        if (obj._id !== item._id) {
          obj.check = false
        }
        if (obj.children && obj.children.length) {
          this.filterRadioStatus(obj.children, item)
        }
      }
    },

    tagsTreeSearch(val) {
      this.tagsSearchValue = val
      this.openTagsPopver()
    },

    clearSelectTags() {
      this.currentMsgTagsKey = []
      this.currentMsgTags = []
      for (let item of this.tagsData) {
        for (let obj of item.list) {
          this.filterTagsData(obj, item.key)
        }
      }
      this.selectTags = []
    },

    getSelectTags() {
      this.selectTags = []
      for (let item of this.tagsData) {
        let list = this.getCheckedNodes(item.list)
        this.getParent(item.list, list)
        this.selectTags = [...this.selectTags, ...this.filterSelectTags(list)]
      }
    },

    getCheckedNodes(data, arr) {
      var res
      if (arr == undefined) {
        res = new Array()
      } else {
        res = arr
      }
      for (var item of data) {
        if (item.check) {
          res.push(item)
        }
        if (item.children !== undefined) {
          this.getCheckedNodes(item.children, res)
        }
      }
      return res
    },

    filterSelectTags(arr) {
      let res = []
      if (arr.length) {
        for (let item of arr) {
          res = [
            ...res,
            {
              parent: item.parentArr,
              key: item.key,
              value: item.value,
              category: item.category
            }
          ]
        }
      }
      return res
    },

    getParent(parentList, list) {
      for (let item of list) {
        if (item.check) {
          let parentArr = this.findParent(parentList, item.parent)
          let arr = []
          for (let data of parentArr.reverse()) {
            arr = [
              ...arr,
              {
                category: data.category,
                key: data.key,
                value: data.value
              }
            ]
          }
          item.parentArr = arr
        } else {
          delete item.parentArr
        }
      }
    },

    findParent(parentList, parentId, arr) {
      var res
      if (arr == undefined) {
        res = new Array()
      } else {
        res = arr
      }
      for (var item of parentList) {
        if (item._id === parentId) {
          res.push(item)
          if (item.parent && item.parent !== null) {
            this.findParent(parentList, item.parent, res)
          }
        } else {
          if (item.children !== undefined) {
            this.findParent(item.children, parentId, res)
          }
        }
      }
      return res
    },

    async tagsConfirm() {
      if (!this.currentMsgItem.msgKey) return
      try {
        this.tagLoading = true
        let params = {
          tagUser: this.userInfo.id,
          MsgKey: this.currentMsgItem.msgKey,
          tags: this.currentMsgTags
        }
        let res = await this.$http.addTagsToFeedback(params)
        this.tagLoading = false
        this.currentMsgItem.tags = res.data.tags
        this.closeTagsPopver()
      } catch (error) {
        this.tagLoading = false
      }
    },

    closeTagsPopver() {
      this.currentMsgItem = null
      this.currentMsgTagsKey = []
      this.currentMsgTags = []
      this.tagsSearchValue = ''
      this.showTagsTree = false
    },

    checkMsgKey() {
      this.$nextTick(async () => {
        if (this.$route.query.MsgKey) {
          let params = {
            MsgKey: this.$route.query.MsgKey
          }
          let res = await this.$http.feedbackSearch(params)
          let { count, results } = res.data
          if (!count || !results.length) {
            this.elMsg('没有搜索到内容', 'info')
          }
          this.searchToHandleUserItem(results[0])
        }
      })
    }
  },
  async mounted() {
    this.checkMsgKey()
  }
}
</script>

<style lang="scss">
.feedback-info-page {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  .feedback-main {
    flex: 1;
    display: flex;
    overflow: hidden;
    .feedback-main-left {
      width: 300px;
      background: #30363e;
      height: 100%;
      display: flex;
      flex-direction: column;
      /* padding: 0 10px; */
      overflow: hidden;
      .feedback-main-left-btn {
        padding: 10px 20px 10px 0;
        border-bottom: 1px solid #ccc;
        display: flex;
        align-items: center;
        justify-content: space-between;
        > .feedback-main-left-select {
          display: flex;
          align-items: center;
          > .el-select {
            width: 80px;
          }
          > .feedback-main-left-sortBy {
            cursor: pointer;
            margin-left: 10px;
            display: flex;
            flex-direction: column;
            > .feedback-main-left-icon {
              color: #ccc;
            }
            > .activeSortIcon {
              color: $globalBGColor;
            }
          }
        }
      }
      .feedback-main-list {
        flex: 1;
        display: flex;
        flex-direction: column;
        .activeUserItem {
          background: #505a64;
        }
        .feedback-main-item {
          display: flex;
          padding: 15px 10px;
          cursor: pointer;
          position: relative;
          &:hover {
            background: #505a64;
            .feedback-del-btn {
              display: block;
            }
          }
          .feedback-del-btn {
            position: absolute;
            right: 10px;
            top: 5px;
            font-size: 18px;
            color: #fff;
            font-weight: bold;
            display: none;
            &:hover {
              color: #ef5655;
            }
          }
          .feedback-main-item-info {
            flex: 1;
            margin-left: 10px;
            overflow: hidden;
            .feedback-main-item-Top {
              display: flex;
              justify-content: space-between;
              padding-right: 20px;
              .feedback-main-item-account {
                width: 85%;
                color: #fff;
                font-weight: bold;
                font-size: 16px;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
              .feedback-main-item-unreadCount {
                width: 20px;
                height: 20px;
                text-align: center;
                border-radius: 50%;
                background: #ef5655;
                color: #fff;
                /* margin-left: 10px; */
              }
            }
            .feedback-main-item-Bottom {
              /* display: flex;
              justify-content: space-between; */
              margin-top: 5px;
              .feedback-main-item-msg {
                width: 90%;
                color: #8e9daa;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
              }
            }
          }
          .feedback-main-item-text {
            color: #8e9daa;
            font-size: 8px;
          }
        }
      }
    }
    .feedback-main-right {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      background: #f3f3f3;
      overflow: hidden;
      .feedback-userName {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
        > h2 {
          flex: 1;
        }
        .blackListBtn {
          /* flex: 1; */
        }
      }
      .feedback-content {
        flex: 1;
        overflow: hidden;
        .scrollButtomTips {
          position: absolute;
          bottom: 5px;
          left: 50%;
          transform: translate(-50%, 0);
          cursor: pointer;
          background: $globalBGColor;
          color: #fff;
          padding: 0px 8px;
          border-radius: 10px;
          font-size: 10px;
          z-index: 100;
        }
        .checkMore-btn {
          text-align: center;
          color: $globalBGColor;
          cursor: pointer;
        }
        .feedbackContent-noMore {
          text-align: center;
          color: #8e9daa;
        }
        .feedbacl-content-item {
          padding: 20px;
          .feedbacl-content-info {
            display: flex;
            .feedback-content-item-pic-wrap {
              display: flex;
              flex-direction: column;
              align-items: center;
            }
            .feedback-content-item-pic {
              width: 50px;
              height: 50px;
              border-radius: 50%;
            }
            .feedback-content-item-info {
              margin: 0 10px;
              width: 60%;
              .feedback-content-item-text-warp {
                display: flex;
                align-items: center;
                .feedback-content-item-tag {
                  width: 20px;
                  height: 20px;
                  margin-left: 10px;
                  cursor: pointer;
                }
              }
              .feedback-content-item-text {
                padding: 5px;
                border-radius: 5px;
                /* word-break: break-all; */
                background: #fff;
                display: inline-block;
                word-wrap: break-word;
                overflow: hidden;
                word-break: break-word;
              }
              .feedback-content-item-firmware {
                margin-top: 5px;
                .feedback-tag-value {
                  color: $globalBGColor;
                  font-weight: bold;
                }
              }
              .feedback-content-item-file {
                margin-top: 5px;
                .feedback-content-item-fileUrl {
                  color: #56a3fd;
                  text-decoration: underline;
                  margin-right: 10px;
                }
              }
              .feedback-content-item-time {
                font-size: 10px;
                color: #8e9daa;
              }
            }
          }
          .feedbacl-content-out {
            justify-content: flex-end;
            .feedbacl-content-out-text {
              position: relative;

              display: flex;
              flex-direction: column;
              align-items: flex-end;
              &:hover {
                .feedback-revoke-btn {
                  display: block;
                }
              }
              .feedback-sendFail-btn {
                font-size: 16px;
                color: #ef5655;
                border-radius: 50px;
                cursor: pointer;
                font-weight: bold;
                margin-right: 5px;
              }
              .feedback-revoke-btn {
                position: absolute;
                right: -5px;
                top: -5px;
                color: #fff;
                border-radius: 50px;
                background: #ef5655;
                cursor: pointer;
                font-weight: bold;
                display: none;
              }
              .feedbacl-out-content-text {
                background: #56a3fd;
                color: #fff;
              }
            }
          }
        }
      }
      .feedback-file {
        display: flex;
        align-items: center;
        padding: 0 10px;
        background: #fff;
        > .feedback-upload-file {
          margin-left: 10px;
        }
      }
      .feedback-input {
        height: 150px;
        border-top: 1px solid #ccc;
        position: relative;
        > .el-textarea {
          > .el-textarea__inner {
            height: 150px;
            border-color: #fff;
          }
        }
        .feedback-sendBtn {
          display: flex;
          position: absolute;
          right: 5px;
          bottom: 5px;
          .feedback-phrase {
          }
        }
      }
    }
  }
  .feedback-dialog-main {
    height: 100%;
    > .el-dialog {
      height: 70%;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      .el-dialog__body {
        flex: 1;
        display: flex;
        overflow: hidden;
      }
      .feedback-dialogSearch-warp {
        flex: 1;
        display: flex;
        flex-direction: column;
        overflow: hidden;
        .feedback-dialogSearch-input {
          display: flex;
          padding: 0 0 10px;
          border-bottom: 1px solid #ccc;
          .feedback-dialogSearch-select {
            width: 100px;
            margin-right: 10px;
          }
          .feedback-dialogSearch-search-icon {
            cursor: pointer;
          }
        }
        .feedback-searchList {
          flex: 1;
          .feedback-searchItem {
            display: flex;
            align-items: center;
            padding: 10px 0;
            border-bottom: 1px dashed #ccc;
            cursor: pointer;
            &:hover {
              background: #f3f6f9;
            }
            .feedback--searchItem-msgInfo {
              flex: 1;
              display: flex;
              align-items: center;
              padding: 0 10px;
              > span {
                flex: 1;
              }
            }
          }
        }
      }
    }
  }
  .feedback-main-item-pic {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
}

.tagsTree-dialog {
  overflow: hidden;
  > .el-dialog {
    margin-top: 4vh !important;
    height: calc(100% - 80px);
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .el-dialog__body {
      flex: 1;
      display: flex;
      flex-direction: column;
      padding: 10px 20px;
      overflow: hidden;
      .feedback-tagsTree-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .feedback-tagsTree-selectTags {
          > .feedback-tag-value {
            color: $globalBGColor;
            font-weight: bold;
          }
        }
        .feedback-tagsTree-btn {
          display: flex;
          align-items: center;
          .feedback-tagsTree-search {
            margin-right: 10px;
          }
        }
      }
      .feedback-tagsTree {
        /* flex: 1; */
        display: flex;
        flex-direction: column;
        border: 1px solid #ccc;
        .feedback-tags-item + .feedback-tags-item {
          border-top: 1px solid #ccc;
        }
        .feedback-tags-item {
          display: flex;
          /* padding: 20px 0; */
          .feedback-tags-item-left {
            display: flex;
            border-right: 1px solid #ccc;
            width: 35%;
            .feedback-tags-item-type {
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              padding: 10px;
            }
            .feedback-tags-funct-list {
              flex: 1;
              border-left: 1px solid #ccc;
              max-height: 290px;
              overflow: hidden;
              .feedback-tags-funct-item {
                padding: 5px 10px;
                margin: 5px 0;
                cursor: pointer;
                &:hover {
                  background: $globalLessBGColor;
                  color: #fff;
                }
              }
              .active-functItem {
                background: $globalLessBGColor;
                color: #fff !important;
              }
              .functItem-color {
                color: $globalBGColor;
              }
            }
          }
          .feedback-tags-item-right {
            flex: 1;
            display: flex;
            overflow: hidden;
            /* align-items: center; */
            max-height: 290px;
            .feedback-tags-list {
              display: flex;
              flex: 1;
              flex-wrap: wrap;
              padding: 0 20px;
              line-height: 40px;
              /* .feedback-tags-item-check + .feedback-tags-item-check {
                margin-left: 20px;
              } */
              .feedback-tags-item-check {
                width: 20%;
                display: flex;
                align-items: center;
                > p {
                  cursor: pointer;
                  margin: 0 20px 0 5px;
                }
              }
            }
          }
        }
        /* .feedback-tagsFunct {
          flex: 1;
        } */
      }
    }
  }
}

.feedback-tags-tree {
  .treeNode {
    .tagsTree-node-scope {
      > .tagsTree-node-wrap {
        display: flex;
        align-items: center;
        margin-top: 14px;
        .tagsTree-node-item {
          position: relative;
          margin-left: 20px;
          .tagsTree-node-expand-btn {
            position: absolute;
            top: 50%;
            left: -14px;
            transform: translate(0, -50%);
            cursor: pointer;
          }
          .tagsTree-node-title {
            cursor: pointer;
          }
        }
      }
    }
    > .tagsTree-node-group {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
    }
    .activeTreeTagTitle {
      color: $globalBGColor;
    }
  }
}
</style>
